// extracted by mini-css-extract-plugin
module.exports = {"team":"_986cc78","name":"_a6f6662","icon":"_6b9ac22"};